import Vue from "vue";

export default {
  createLeave({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      Vue.$http
        .post("/hrm/leaves", data)
        .then(response => {
          commit("tableLoader", false);
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
          commit("tableLoader", false);
        });
    });
  },
  updateLeave(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/leaves/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getEmployeeleaves({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
        ...(state.filterLeaveTypes != "" && {
          leave_type_id: state.filterLeaveTypes,
        }),
      };

      Vue.$http
        .get("hrm/leaves/me", { params })
        .then(response => {
          commit("leavesData", response.data.results);
          commit("essleaveTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeave({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leaves/${id}`)
        .then(response => {
          commit("currentLeave", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getLeaveByEmployee({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/leave-types-by-employee?employee_id=${id}`)
        .then(response => {
          commit("employeeLeave", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteLeave(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/leaves/delete/`, { leave_ids: id })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getAllApprovals({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentApprovalPage,
        perPage: state.perPageApproval,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
        ...(state.filterLeaveTypes != "" && {
          leave_type_id: state.filterLeaveTypes,
        }),
      };

      Vue.$http
        .get("/hrm/leaves/approvals", { params })
        .then(response => {
          commit("approvals", response.data.results);
          commit("totalLeaveApprover", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getAllLeaveTypes({ commit }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      Vue.$http
        .get("/hrm/leaves/settings/leavetypes")
        .then(response => {
          commit("leaveTypes", response.data);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification("error", error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  approveLeavesStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/leaves/${endpoint}`, { leave_request_ids: ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  approveMultipleLeave(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("hrm/leaves/approve", id)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectMultipleLeave(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("hrm/leaves/reject", id)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  rejectLeavesStatus(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`hrm/leaves/reject/${id}`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getEmployeeleaves");
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getEmployeeleaves");
  },
  handleSizeChangeApproval({ commit, dispatch }, perPageApproval) {
    commit("perPageApproval", perPageApproval);
    commit("currentApprovalPage", 1);
    dispatch("getAllApprovals");
  },
  handleCurrentChangeApproval({ commit, dispatch }, page) {
    commit("currentApprovalPage", page);
    dispatch("getAllApprovals");
  },
};
